module.exports = function (Point, Utils) {
    'use strict';
    function WaveformPoints(peaks) {
        this._peaks = peaks;
        this._points = [];
        this._pointsById = {};
        this._pointIdCounter = 0;
    }
    WaveformPoints.prototype._getNextPointId = function () {
        return 'peaks.point.' + this._pointIdCounter++;
    };
    WaveformPoints.prototype._addPoint = function (point) {
        this._points.push(point);
        this._pointsById[point.id] = point;
    };
    WaveformPoints.prototype._createPoint = function (options) {
        var pointOptions = { peaks: this._peaks };
        Utils.extend(pointOptions, options);
        if (Utils.isNullOrUndefined(pointOptions.id)) {
            pointOptions.id = this._getNextPointId();
        }
        if (Utils.isNullOrUndefined(pointOptions.labelText)) {
            pointOptions.labelText = '';
        }
        if (Utils.isNullOrUndefined(pointOptions.editable)) {
            pointOptions.editable = false;
        }
        return new Point(pointOptions);
    };
    WaveformPoints.prototype.getPoints = function () {
        return this._points;
    };
    WaveformPoints.prototype.getPoint = function (id) {
        return this._pointsById[id] || null;
    };
    WaveformPoints.prototype.find = function (startTime, endTime) {
        return this._points.filter(function (point) {
            return point.isVisible(startTime, endTime);
        });
    };
    WaveformPoints.prototype.add = function () {
        var self = this;
        var points = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
        points = points.map(function (pointOptions) {
            var point = self._createPoint(pointOptions);
            if (Utils.objectHasProperty(self._pointsById, point.id)) {
                throw new Error('peaks.points.add(): duplicate id');
            }
            return point;
        });
        points.forEach(function (point) {
            self._addPoint(point);
        });
        this._peaks.emit('points.add', points);
    };
    WaveformPoints.prototype._findPoint = function (predicate) {
        var indexes = [];
        for (var i = 0, length = this._points.length; i < length; i++) {
            if (predicate(this._points[i])) {
                indexes.push(i);
            }
        }
        return indexes;
    };
    WaveformPoints.prototype._removeIndexes = function (indexes) {
        var removed = [];
        for (var i = 0; i < indexes.length; i++) {
            var index = indexes[i] - removed.length;
            var itemRemoved = this._points.splice(index, 1)[0];
            delete this._pointsById[itemRemoved.id];
            removed.push(itemRemoved);
        }
        return removed;
    };
    WaveformPoints.prototype._removePoints = function (predicate) {
        var indexes = this._findPoint(predicate);
        var removed = this._removeIndexes(indexes);
        this._peaks.emit('points.remove', removed);
        return removed;
    };
    WaveformPoints.prototype.remove = function (point) {
        return this._removePoints(function (p) {
            return p === point;
        });
    };
    WaveformPoints.prototype.removeById = function (pointId) {
        return this._removePoints(function (point) {
            return point.id === pointId;
        });
    };
    WaveformPoints.prototype.removeByTime = function (time) {
        return this._removePoints(function (point) {
            return point.time === time;
        });
    };
    WaveformPoints.prototype.removeAll = function () {
        this._points = [];
        this._pointsById = {};
        this._peaks.emit('points.remove_all');
    };
    return WaveformPoints;
}(require('./point'), require('./utils'));